import Cookie from "js-cookie";
import axios from "axios";
import urls from "./url";

const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";
const REFRESH_TOKEN_TTL_DAYS = 30;
// How long the browser keeps the access_token cookie. This is deliberately
// NOT the JWT's own lifetime (expires_in): the login gate and every page only
// check that the cookie exists, so if it vanished when the JWT expired a
// returning user would land on the login page even though the 30-day refresh
// token is still valid. An expired JWT is handled by the 401 -> refresh flow
// (authInterceptors.js for REST, keyarSocket.js for WebSocket).
const ACCESS_COOKIE_TTL_DAYS = REFRESH_TOKEN_TTL_DAYS;

function secureCookieOptions(expiresInDays) {
  return {
    expires: expiresInDays,
    path: "/",
    secure: true,
    sameSite: "strict",
  };
}

export function getAccessToken() {
  return Cookie.get(ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
  return Cookie.get(REFRESH_TOKEN_KEY);
}

export function setTokens({ access_token, refresh_token }) {
  if (access_token) {
    Cookie.set(ACCESS_TOKEN_KEY, access_token, secureCookieOptions(ACCESS_COOKIE_TTL_DAYS));
  }
  if (refresh_token) {
    Cookie.set(REFRESH_TOKEN_KEY, refresh_token, secureCookieOptions(REFRESH_TOKEN_TTL_DAYS));
  }
}

export function clearTokens() {
  Cookie.remove(ACCESS_TOKEN_KEY, { path: "/" });
  Cookie.remove(REFRESH_TOKEN_KEY, { path: "/" });
}

// Same refresh call authInterceptors.js makes for REST, but usable
// anywhere — in particular, the WebSocket connection manager has no axios
// request to hang a 401-retry off of, so it needs to trigger this itself
// on an auth-failure close code rather than silently reconnecting with
// the same stale token. Concurrent callers share one in-flight request.
let refreshPromise = null;

export function refreshAccessToken() {
  const refreshToken = getRefreshToken();
  if (!refreshToken) return Promise.resolve(null);

  if (!refreshPromise) {
    refreshPromise = axios
      .post(
        `${urls.DEV_URL}v1/nurse/refresh-token/`,
        { refresh_token: refreshToken },
        { headers: { "Request-ID": "allow|me", "Content-Type": "application/json" } }
      )
      .then((res) => {
        const tokens = res.data?.response ?? res.data;
        setTokens(tokens);
        return tokens.access_token;
      })
      .catch(() => null)
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}
